import { useEffect } from "react";
// my imports:
import { saveHistory, saveLastVisitedGameMode, saveLastVisitedLevelID, savePyramidState, saveStoryState, saveStreak } from "@/app/lib/system/local-storage";
import { GameManager } from "@/app/lib/game-state/game-manager";
import * as Util from "@/app/lib/system/util";
import { PyramidGameState } from "@/app/lib/game-state/pyramid-game-state";
import UI from "@/app/lib/ui/ui";
import { StoryGameState, StorySnapshot } from "@/app/lib/game-state/story-game-state";
import { UserHistory } from "@/app/lib/ui/user-history";

export function useAutoSave(gameManager: GameManager, ui: UI) {

    // autosave for user history
    useEffect(() => {
        // NEVER SAVE AN EMPTY USER HISTORY
        // WE DO NOT EVER WANT TO OVERWRITE USER HISTORY WITH EMPTY, e.g. ON LOAD
        if (ui.userHistory.exportJSON() === new UserHistory().exportJSON()) {
            return;
        }
        saveHistory(ui.userHistory);
        Util.devLog(`Saved user history.`)
    }, [ui.userHistory]);

    // autosave for the last game mode the user was on
    useEffect(() => {
        saveLastVisitedGameMode(gameManager.activeMode);
    }, [gameManager.activeMode]);

    // autosave for the last level the user was on
    // don't love that it gets its own effect, but annoying right now to put in user history
    useEffect(() => {
        const levelNumber = gameManager.levels.current;
        const levelData = gameManager.levels.fullStory.getLevelByNumber(levelNumber);
        if (!levelData)
            return;

        saveLastVisitedLevelID(levelData.levelID);
    }, [gameManager.levels.current]);

    // autosave for pyramid
    useEffect(() => {
        const pyramidState: PyramidGameState = gameManager.pyramid.state;
        savePyramidState(pyramidState);
        Util.devLog(`Saved game ${pyramidState.version} to local storage.`)
    }, [
        gameManager.pyramid.state.solutions, // changes on a new puzzle fetch
        gameManager.pyramid.state.usedSolutions, // changes on a word solve
        gameManager.pyramid.state.completed // currently redundant with usedSolutions but useful for future edge cases maybe
    ]);

    // autosave for story 
    useEffect(() => {
        const storyState: StoryGameState = gameManager.story.state;
        if (storyState.levelID === '')
            return;

        const storySnapshot: StorySnapshot = storyState.exportSnapshot();
        gameManager.levels.snapshotMap.set(storyState.levelID, storySnapshot);
        saveStoryState(storyState);
    }, [
        gameManager.story.state.usedSolutions,
        gameManager.story.state.completed
    ])
}